const text = value => value == null ? "" : String(value).trim();
const fields = ["rangeName", "rangeAddress", "city", "state", "postalCode", "country", "latitude", "longitude", "timeZone", "placeId", "provider"];

export function venueFormValue(venue) {
  return Object.fromEntries(fields.map(field => [field, text(venue?.[field])]));
}

export function venueSelectionPatch(venue) {
  const result = { ...venueFormValue(venue), mapLocation: null };
  // A historical/manual venue without a zone must not erase an explicitly chosen match zone.
  if (!result.timeZone) delete result.timeZone;
  return result;
}

export function clearVenueLocation() {
  return { latitude: "", longitude: "", mapLocation: null, placeId: "", provider: "" };
}

export const venueAddressLabel = venue => [venue?.rangeAddress, venue?.city, venue?.state, venue?.postalCode, venue?.country].filter(Boolean).join(", ");
